const eventsMap = {};
const subscribers = {};
const locked = {};
const lockQueue = {};

function lock (eventName) {
    locked[eventName] = true;
};

function getLockQueue (eventName) {
    if (!lockQueue[eventName]) {
        lockQueue[eventName] = [];
    }
    return lockQueue[eventName];
}

function unlock (eventName) {
    locked[eventName] = false;

    const queue = lockQueue[eventName];
    while(queue && queue.length) {
        const { caller, eventName, handler } = queue.shift();

        caller(eventName, handler);
    }
}

export const STATE_UPDATED = 'state/updated';
export const COMMON_INITIALIZED = 'common/initialized';
export const GENERIC_CONFIG = 'generic/configuration';
export const GENERIC_SHOW = 'generic/show';
export const GENERIC_ACHIEVEMENT_PROGRESS = 'generic/achievementProgress';
export const GENERIC_TOTAL_ROUND_WINNINGS = 'generic/totalRoundWinnings';
export const LOAD_END = 'loadingComplete';
export const ERROR_OUT_OF_MONEY = 'outOfMoney';
export const UI_ENABLED = 'uiEnabled';
export const LOGOUT = 'logout';
export const CLOSE_GAME = 'closeGame';
export const ENGINE_BALANCE_UPDATE = 'engineBalanceUpdate';
export const BET_CHANGED = 'betChanged';
export const GAME_ROUND_ENDED = 'gameRoundEnded';
export const ENGINE_CUSTOM_MESSAGE = 'engineCustomMessage';

export const BUY_BUTTON = 'buyButtonClicked';
export const BUY_REQUEST = 'buyRequest';


export const FREE_SPIN_ANIMATION_ENDED = 'free-spins/animation/ended';
export const FREE_SPIN_ANIMATION_START = 'free-spins/animation/start';
export const ROUND_ANIMATION_ENDED = 'round/animation/ended';
export const GAME_ACTION_ANIMATION_ENDED = 'game-action/animation/ended';

export const FREE_ROUNDS_START = 'freeeRounds/start';
export const FREE_ROUNDS_PROGRESS = 'freeeRounds/progress';
export const FREE_ROUNDS_END = 'freeeRounds/end';
export const FREE_ROUNDS_UNSPECIFIED = 'freeeRounds/unspecified';

export const AUTOPLAY_ENDED = 'autoplay/ended';
export const AUTOPLAY_START = 'autoplay/start';
export const AUTOPLAY_UPDATED = 'autoplay/updated';
export const AUTOPLAY_OPEN = 'autoplay/open';

export const GENERIC_FREE_RETRIGGER = 'generic/freeSpinsRetrigger';
export const GENERIC_FREE_SPIN_START = 'generic/freeSpinsStart';
export const GENERIC_FREE_SPIN_END = 'generic/freeSpinsEnd';
export const GENERIC_FREE_SPIN_PROGRESS = 'generic/freeSpinsProgress';
export const GENERIC_CASCADE_START = 'generic/cascadesStart';
export const GENERIC_CASCADE_END = 'generic/cascadesEnd';
export const GENERIC_CASCADE_PROGRESS = 'generic/cascadesProgress';

export const SPIN_REQUEST = 'spin/request';
export const SPIN_RESPONSE = 'spin/response';
export const GENERIC_REDEEN_START = 'generic/redeemStart';
export const REDEEM_REQUEST = 'redeem/request';
export const REDEEM_RESPONSE = 'redeem/response';

export const BUTTON_SPIN = 'spin';
export const BUTTON_SLAMSTOP = 'slamStop';
export const ROUND_HISTORY_RECEIVED = 'roundsHistoryReceived';
export const ROUND_HISTORY_REQUEST = 'roundsHistoryRequest';
export const REALITY_CHECK = 'realityCheck';
export const BUTTON_STOP_AUTOPLAY = 'stopAutoplay';
export const BUTTON_FAST_POPUP = 'openFastModePopup';
export const MENU_OPENED = 'common-ui/window/opened';
export const MENU_CLOSED = 'common-ui/window/closed';
export const GAME_CLOSED = 'home';
export const GAME_RULES = 'gameRules';
export const FEATURE_STATE_UPDATED = 'featureStateUpdated';
export const WIN_RESTORE_RESPONSE = 'winRestoreResponse';
export const GAME_INNTER_CANVAS_SIZE_CHANGED = 'gameInnerCanvasSizeChanged';
export const ERROR_DIALOG = 'error/dialog';

export const GAME_PAUSED = 'game/pause';
export const GAME_RESUMED = 'game/resume';

export const START_REPLAY = 'startReplay';
export const STOP_REPLAY = 'stopReplay';

export const START_SCENE_LOAD = 'startSceneLoad';
export const SCENE_LOAD_COMPLETE = 'sceneLoadComplete';

export function subscribe(eventName, handler, target) {
    if (locked[eventName]) {
        getLockQueue(eventName).push({ caller: subscribe, eventName, handler, target });
        return;
    }

    handler.target = target || null;

    if (!subscribers.hasOwnProperty(eventName)) {
        subscribers[eventName] = [handler];
    } else {
        subscribers[eventName].push(handler);
    }
}
export function unsubscribe(eventName, handler) {
    if (locked[eventName]) {
        getLockQueue(eventName).push({ caller: unsubscribe, eventName, handler });
        return;
    }
    if (subscribers.hasOwnProperty(eventName)) {
        const array = subscribers[eventName];

        const index = array.indexOf(handler);
        if (index > -1) {
            array.splice(index, 1);
        }
    }
}
export function removeAllListenerByTarget(target) {
    for (const eventName in subscribers) {
        const list = subscribers[eventName];

        subscribers[eventName] = list.filter(handler => handler.target !== target);
    }
}
export function publish(eventName, data) {
    if (CC_PREVIEW) {
        cc.log(eventName, data);
    }
    lock(eventName);
    eventsMap[eventName] = data;
    if (subscribers.hasOwnProperty(eventName)) {
        const list = subscribers[eventName];

        list.forEach((handler) => {
            if(handler.target) {
                handler.call(handler.target, data);
            } else {
                handler(data);
            }
        });
    }

    unlock(eventName);
}

export function onEngineInitialized(callBack) {
    const data = getLast(COMMON_INITIALIZED);
    if (data) {
        callBack(data)
    } else {
        const listener = (data) => {
            callBack(data);
            unsubscribe(COMMON_INITIALIZED, listener);
        }
        subscribe(COMMON_INITIALIZED, listener);
    }
}


/**
 * if the event has been pusblished will trigger callback with the last data immediatelly
 * And will continue to be subscribed to the event
 */
export function getLastAndSubscribe (eventName, callBack) {
    if (eventsMap.hasOwnProperty(eventName)) {
        callBack(eventsMap[eventName]);
    }
    subscribe(eventName, callBack);
}

/**
 * if the event has been pusblished will trigger callback with the last data immediatelly
 * if not will listen to event and after trigger callback
 */
export function getLastOrSubscribe (eventName, callBack) {
    const data = eventsMap[eventName];

    if (eventsMap.hasOwnProperty(eventName)) {
        return callBack(data);
    } else {
        const listener = (data) => {
            unsubscribe(eventName, listener);

            callBack(data);
        }
        subscribe(eventName, listener);
    }
}

export function getLast(eventName) {
    return eventsMap[eventName];
}
